import { Component, OnInit } from '@angular/core';
import { PageDTO } from '@dto/PageDTO';
import { PatientDTO } from '@dto/patient/PatientDTO';
import { PatientInsuranceType } from '@enum/patient/PatientInsuranceType';
import { ApplicationModel } from '@model/ApplicationModel';
import { StateService } from '@uirouter/core';
import { Transition } from '@uirouter/angular';
import { State } from '@common/State';
import { PageCriteriaDTO } from '@dto/PageCriteriaDTO';
import { DataGridTemplateCellRendererComponent } from 'app/component/ui/dataGrid/cellRenderer/DataGridTemplateCellRendererComponent';
import { Constant } from '@common/Constant';
import { PatientStatus } from '@enum/patient/PatientStatus';
import { PatientAdminPageEntityDTO } from '@dto/patient/PatientAdminPageEntityDTO';
import { PatientAdminPageCriteriaDTO } from '@dto/patient/PatientAdminPageCriteriaDTO';
import { PatientAdminService } from '@service/PatientAdminService';
import { ViewUtil } from '@util/ViewUtil';
import { PageUtil } from '@util/PageUtil';
import { FileUtil } from '@util/FileUtil';
import { PatientAdminExportCriteriaDTO } from '@dto/patient/PatientAdminExportCriteriaDTO';
import { InsuranceType } from '@enum/doctor/InsuranceType';

@Component({
  selector: 'app-patient-admin-list',
  templateUrl: './PatientAdminListComponent.html',
  styleUrls: [ './PatientAdminListComponent.scss' ]
})
export class PatientAdminListComponent implements OnInit {
  public data: PageDTO<PatientAdminPageEntityDTO>;

  public criteria: PatientAdminPageCriteriaDTO;

  public DataGridTemplateCellRendererComponent: typeof DataGridTemplateCellRendererComponent = DataGridTemplateCellRendererComponent;

  public Constant: typeof Constant = Constant;

  public PatientStatus: typeof PatientStatus = PatientStatus;

  public insuranceTypes: PatientInsuranceType[] = Object.keys(PatientInsuranceType) as PatientInsuranceType[];

  public statuses: PatientStatus[] = Object.keys(PatientStatus) as PatientStatus[];

  constructor(private applicationModel: ApplicationModel,
              private stateService: StateService,
              private transition: Transition,
              private viewUtil: ViewUtil,
              private fileUtil: FileUtil,
              private patientService: PatientAdminService) {
    this.criteria = PageUtil.prepareCriteria<PatientAdminPageCriteriaDTO>(PatientAdminPageCriteriaDTO, transition.params()?.criteria);
    this.applicationModel.selectSideBarItemWithState(State.MAIN.PATIENT.LIST);
  }

  public ngOnInit(): void {
    this.getData();
  }

  public export(): void {
    const exportCriteria = new PatientAdminExportCriteriaDTO();

    this.patientService.getExcelReport(exportCriteria).toPromise()
      .then((file: File) => this.fileUtil.saveFile(file))
      .catch((ex) => {
        this.viewUtil.handleServerError(ex);
      });
  }

  public goDetails(data: PatientDTO): void {
    this.stateService.go(State.MAIN.MY_PATIENT.DETAILS.BASIC_DATA, { patientId: data.id });
  }

  public onInsuranceTypeFilterChanged(insuranceType: PatientInsuranceType): void {
    this.onCriteriaChanged({ ...this.criteria, insuranceType } as PageCriteriaDTO);
  }

  public onStatusFilterChanged(status: PatientStatus): void {
    this.onCriteriaChanged({ ...this.criteria, status } as PageCriteriaDTO);
  }

  public onCriteriaChanged(changedCriteria: PageCriteriaDTO): void {
    this.criteria = PageUtil.onCriteriaChanged<PatientAdminPageCriteriaDTO>(PatientAdminPageCriteriaDTO, this.criteria, changedCriteria as PatientAdminPageCriteriaDTO);

    this.getData()
      .then(() => PageUtil.updateURL(changedCriteria));
  }

  private getData(): Promise<void> {
    return this.patientService.getPage(this.criteria).toPromise()
      .then((result: PageDTO<PatientAdminPageEntityDTO>) => {
        this.data = result;
      })
      .catch((ex) => {
        this.viewUtil.handleServerError(ex);
      });
  }
}
